import axios from "axios";
import axiosRetry from "axios-retry";
import ApiError from "../exceptions/apiError";
import { getEndpointUrl, getToken, onLogout } from "../config";

axiosRetry(axios, {
  retries: 5,
  retryCondition: (error) => {
    if (
      !!error?.response?.config?.url?.includes("speech-recognition") ||
      !!error?.response?.config?.url?.includes("simple-speech-score")
    ) {
      return false;
    }
    return axiosRetry.isRetryableError(error);
  },
  retryDelay: (retryCount) => retryCount * 2500,
});

const request = async ({ url, version = "v1", method = "GET", headers, params, data }) => {
  try {
    console.log(getEndpointUrl());
    const response = await axios({
      headers: {
        Authorization: `Bearer ${await getToken()}`,
        ...headers,
      },
      url: `${getEndpointUrl()}/${version}/${url}`,
      method,
      params,
      data,
    });
    return response.data;
  } catch (error) {
    const token = await getToken();
    if (error.response && error.response.status === 401 && !!token) {
      onLogout();
    }

    throw new ApiError(error);
  }
};

export default request;
